export default __webpack_public_path__ + "static/media/Simple-Line-Icons.5c9febce.woff";